import { isCustomizedType, reduce } from "et3-type-guards";

import i18nServerResponse from "../../constants/i18n-server-response";
import { post } from "../axios-post";
import { Ti18nKeys } from "../../constants/i18n";
import { TUserInvestigationCase } from "../../Types";

export const apiCallGetInvestigationCaseByID = async ({
  userID
}: {
  userID: number;
}): Promise<{
  data: TUserInvestigationCase;
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<TUserInvestigationCase>(
    `investigationCases/getInvestigationCaseByID`,
    {
      userID
    }
  );
  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data: {
        investigationCase: data.investigationCase,
        pool: data.pool
      },
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: {
        investigationCase: [],
        pool: ""
      },
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: {
        investigationCase: [],
        pool: ""
      },
      status: "ERROR",
      code: "ERROR"
    };
  }
};
